import { campaignUrlId } from '@/features/campaign/campaign-url-id';

export const OPERATIONS_HOME = '/operations/campaigns';

/** *Gelen Medya* under *Operasyon İşlemleri* — docs/decisions/0093. */
export const INBOUND_MEDIA_HOME = '/operations/inbound-media';

/** A campaign's operations page, on one of its stages, with any further parameters. */
export function operationsCampaignPath(
  campaignId: string,
  params: Record<string, string | undefined> = {},
): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) query.set(key, value);
  }
  const text = query.toString();
  return `${OPERATIONS_HOME}/${campaignId}${text ? `?${text}` : ''}`;
}

/**
 * **Where an old link to the fulfilment work lands now** — docs/decisions/0091.
 * The work left the donation list for *Operasyon İşlemleri*, and every link
 * somebody saved, bookmarked or was sent keeps working rather than breaking:
 *
 * - the fulfilment inbox `/donations?inbox=1…` and the *Görev Kutusu*
 *   `/donations?assigned=1…` open the operations campaigns, or the campaign's
 *   own page when the link named one;
 * - the queue screen `/donations/queue?campaign=…&period=…&sort=…` opens the
 *   campaign's order, on the same season and sort, or the campaigns when it
 *   named none;
 * - *Gelen Medya*'s old `/inbound-media` opens its place under the operations
 *   menu, keeping its tab and filters (docs/decisions/0093).
 *
 * Anything else on the donation list is the list's own, and answers null.
 */
export function legacyOperationsTarget(pathname: string, search: string): string | null {
  if (pathname === '/inbound-media' || pathname === '/inbound-media/') {
    return `${INBOUND_MEDIA_HOME}${search}`;
  }
  const params = new URLSearchParams(search);
  const campaignId = campaignUrlId(params.get('campaign'));

  if (pathname === '/donations/queue') {
    if (!campaignId) return OPERATIONS_HOME;
    return operationsCampaignPath(campaignId, {
      tab: 'queued',
      view: 'order',
      period: campaignUrlId(params.get('period')),
      queueSort: params.get('sort') ?? undefined,
    });
  }

  if (
    pathname === '/donations' &&
    (params.get('inbox') === '1' || params.get('assigned') === '1')
  ) {
    return campaignId ? operationsCampaignPath(campaignId) : OPERATIONS_HOME;
  }
  return null;
}
